/**
 * @generated SignedSource<<c6e722199b0ad516efd23840c49657a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CardTypeCriterion = "Internal" | "Market" | "%future added value";
export type JobRateType = "Contract" | "FTE" | "%future added value";
export type SavedSearchSortField = "CITY" | "CLIENT_NAME" | "COUNTRY" | "CREATE_DATE" | "INDUSTRY_ID" | "IS_DRAFT" | "JOB_LABEL" | "JOB_TITLE" | "LOCATION" | "LOCATION_FULL_LABEL" | "OWNER_FIRST_NAME" | "REGION" | "REVERSE_CREATED_DATE" | "STATE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type SavedSearchFiltersInput = {
  active?: boolean | null;
  cardType?: CardTypeCriterion | null;
  cities?: ReadonlyArray<CityCriterionInput | null> | null;
  clientIdIn?: ReadonlyArray<string | null> | null;
  clientidIn?: ReadonlyArray<number | null> | null;
  countries?: ReadonlyArray<CountryCriterionInput | null> | null;
  createdBy?: ReadonlyArray<number | null> | null;
  createdById?: ReadonlyArray<string | null> | null;
  deleted?: boolean | null;
  exclude?: ReadonlyArray<string | null> | null;
  fromDate?: string | null;
  fromDateTime?: string | null;
  industries?: ReadonlyArray<string | null> | null;
  isDraft?: boolean | null;
  isRegionSearch?: boolean | null;
  jobLabelIContains?: string | null;
  jobLabels?: ReadonlyArray<JobLabelCriterionInput | null> | null;
  jobTitleIContains?: string | null;
  jobTitles?: ReadonlyArray<JobTitleCriterionInput | null> | null;
  levels?: ReadonlyArray<string | null> | null;
  locationId?: ReadonlyArray<string | null> | null;
  locations?: LocationsCriterionInput | null;
  only?: ReadonlyArray<string | null> | null;
  rateCardId?: string | null;
  rateType?: JobRateType | null;
  regionIdIn?: ReadonlyArray<string | null> | null;
  regions?: ReadonlyArray<RegionCriterionInput | null> | null;
  states?: ReadonlyArray<StateCriterionInput | null> | null;
  strictCountries?: ReadonlyArray<CountryCriterionInput | null> | null;
  strictLevels?: ReadonlyArray<string | null> | null;
  tagIdIn?: ReadonlyArray<string | null> | null;
  tagnameIn?: ReadonlyArray<string | null> | null;
  toDate?: string | null;
  toDateTime?: string | null;
};
export type RegionCriterionInput = {
  region?: string | null;
};
export type CountryCriterionInput = {
  country?: string | null;
};
export type StateCriterionInput = {
  state?: string | null;
};
export type CityCriterionInput = {
  city?: string | null;
};
export type LocationsCriterionInput = {
  cities?: ReadonlyArray<CityCriterionInput | null> | null;
  countries?: ReadonlyArray<CountryCriterionInput | null> | null;
  regions?: ReadonlyArray<RegionCriterionInput | null> | null;
  states?: ReadonlyArray<StateCriterionInput | null> | null;
};
export type JobLabelCriterionInput = {
  jobLabel?: string | null;
};
export type JobTitleCriterionInput = {
  jobTitle?: string | null;
};
export type SavedSearchSortInput = {
  caseSensitive?: boolean | null;
  direction?: SortDirection | null;
  field: SavedSearchSortField;
};
export type AdminSearchesPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  filters?: SavedSearchFiltersInput | null;
  order?: ReadonlyArray<SavedSearchSortInput | null> | null;
};
export type AdminSearchesPaginationQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminSearches_viewer">;
  } | null;
};
export type AdminSearchesPaginationQuery = {
  response: AdminSearchesPaginationQuery$data;
  variables: AdminSearchesPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v5 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v6 = {
  "kind": "Literal",
  "name": "section",
  "value": "ADMIN"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = [
  "filters"
],
v20 = {
  "kind": "Literal",
  "name": "filters",
  "value": {}
},
v21 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v22 = {
  "kind": "Literal",
  "name": "order",
  "value": [
    {
      "direction": "ASC",
      "field": "NAME"
    }
  ]
},
v23 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = [
  (v20/*: any*/),
  (v21/*: any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "direction": "ASC",
        "field": "USERNAME"
      }
    ]
  },
  (v6/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v26 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminSearchesPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "AdminSearches_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminSearchesPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "SaveSearchNodeConnection",
            "kind": "LinkedField",
            "name": "savedsearches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SaveSearchNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SaveSearchNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegacyUserNode",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobResponse",
                        "kind": "LinkedField",
                        "name": "job",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitleId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobLabel",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "country",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewRegionNode",
                        "kind": "LinkedField",
                        "name": "region",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rateType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CurrencyNode",
                        "kind": "LinkedField",
                        "name": "currency",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "symbol",
                            "storageKey": null
                          },
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MarketRateNode",
                        "kind": "LinkedField",
                        "name": "marketRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "payRate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billRate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPct",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagNode",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tagId",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDraft",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGlobalSupplierSearch",
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": (v19/*: any*/),
            "handle": "connection",
            "key": "AdminSearches_savedsearches",
            "kind": "LinkedHandle",
            "name": "savedsearches"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "ClientTypeNodeConnection",
            "kind": "LinkedField",
            "name": "allClients",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientId",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allClients(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"NAME\"}])"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "filters": (v19/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortClients_allClients",
            "kind": "LinkedHandle",
            "name": "allClients"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "AuthorNodeConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": "authors(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"USERNAME\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "filters": (v19/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortCreatedBy_authors",
            "kind": "LinkedHandle",
            "name": "authors"
          },
          {
            "alias": null,
            "args": (v26/*: any*/),
            "concreteType": "TagNodeConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TagNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": "tags(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"NAME\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v26/*: any*/),
            "filters": (v19/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortTags_tags",
            "kind": "LinkedHandle",
            "name": "tags"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e5639c40097d60c19349e3a71ef1421",
    "id": null,
    "metadata": {},
    "name": "AdminSearchesPaginationQuery",
    "operationKind": "query",
    "text": "query AdminSearchesPaginationQuery(\n  $filters: SavedSearchFiltersInput\n  $order: [SavedSearchSortInput]\n  $count: Int\n  $cursor: String\n) {\n  viewer {\n    ...AdminSearches_viewer_1CnIei\n  }\n}\n\nfragment AdminSearchesSearch_search on SaveSearchNode {\n  id\n  searchId\n  createdDate\n  createdBy {\n    userId\n    username\n    firstName\n    lastName\n  }\n  job {\n    id\n    jobTitleId\n    jobTitle\n    jobLabel\n  }\n  city\n  state\n  country\n  region {\n    name\n    id\n  }\n  rateType\n  currency {\n    symbol\n    id\n  }\n  marketRate {\n    payRate\n    billRate\n    markupPct\n  }\n  tags {\n    tagId\n    name\n    id\n  }\n  isDraft\n  isGlobalSupplierSearch\n}\n\nfragment AdminSearches_viewer_1CnIei on Viewer {\n  savedsearches(first: $count, after: $cursor, filters: $filters, order: $order, section: ADMIN) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        searchId\n        ...AdminSearchesSearch_search\n        __typename\n      }\n    }\n  }\n  ...FilterAndSortClients_viewer\n  ...FilterAndSortCreatedBy2_viewer\n  ...FilterAndSortTags_viewer\n}\n\nfragment FilterAndSortClients_viewer on Viewer {\n  allClients(first: 10, filters: {}, order: [{direction: ASC, field: NAME}]) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        clientId\n        name\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment FilterAndSortCreatedBy2_viewer on Viewer {\n  authors(first: 10, filters: {}, order: [{direction: ASC, field: USERNAME}], section: ADMIN) {\n    edges {\n      node {\n        id\n        userId\n        firstName\n        lastName\n        username\n        email\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FilterAndSortTags_viewer on Viewer {\n  tags(first: 10, filters: {}, order: [{direction: ASC, field: NAME}], section: ADMIN) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "78b05c2f5a7d30edd6349554b3176f7b";

export default node;
